export default "__VITE_ASSET__DPOvPt92__"